export default __webpack_public_path__ + "static/luxor-management-logo-44973bec6a498d734d783b0ab75f0ead.svg";